import { render } from "./SubmissionTables.vue?vue&type=template&id=ddc21866&scoped=true"
import script from "./SubmissionTables.vue?vue&type=script&lang=js"
export * from "./SubmissionTables.vue?vue&type=script&lang=js"

import "./SubmissionTables.vue?vue&type=style&index=0&id=ddc21866&scoped=true&lang=css"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddc21866"]])

export default __exports__